import React from 'react';
import './CompanyList.css';

const CompanyList = () => {
  const companies = [
    { name: 'Cage Farms', link: 'https://cagefarms.com' },
    { name: 'Cage Interactive', link: 'https://cageinteractive.com' },
    { name: 'SONS World Music', link: 'https://sonsworldmusic.com' },
    { name: 'Marshley', link: 'https://marshley.com' },
    { name: 'Sugar Bindles', link: 'https://sugarbindles.com' }
  ];

  return (
    <div className="company-list"> 
      {companies.map((company) => (
        <a key={company.name} href={company.link} target="_blank" rel="noopener noreferrer" className="company-item">
          <div className="gradient-ring">
            <div className="inner-circle"></div>
          </div>
          <span className="company-name">{company.name}</span>
        </a>
      ))}
    </div>
  );
};

export default CompanyList;
